import React, { memo } from 'react';
import Roadmap from 'app/components/RoadmapCard/Roadmap';
import { useSyncFilteredReleases } from 'app/shared/filteredReleases/useSyncFilteredReleases';
import { useMonthlyTimelineSlice } from './store/monthlyTimelineSlice';
import { MonthlyRoadmap } from './Loadable';
import { useTimelineViewTransition } from './hooks/useTimelineViewTransition';

export const TimelineViewRouter = memo(() => {
  useMonthlyTimelineSlice();
  const { displayedTimelineViewMode } = useTimelineViewTransition();
  const isMonthlyView = displayedTimelineViewMode === 'monthly';

  // Quarterly Roadmap owns filter sync when mounted; monthly view needs the same logic here.
  useSyncFilteredReleases(isMonthlyView);

  if (isMonthlyView) {
    return <MonthlyRoadmap />;
  }

  return <Roadmap />;
});
